<script setup lang="ts">
defineProps({
  object: {
    type: Object as PropType<Sanity.Default.Schema.Feature>,
    required: true,
  },
})

const { urlFor } = useSanityImage()
</script>

<template>
  <UiFader>
    <div v-if="object" class="mb-20 max-w-5xl mx-auto px-4">
      <div class="grid lg:grid-cols-2 gap-12 lg:gap-16 h-full items-center">
        <div
          class="z-20"
          :class="{
            'lg:order-1': object.imagePosition === 'imageLeft',
            'lg:order-2': object.imagePosition !== 'imageLeft',
          }"
        >
          <nuxt-img
            v-if="object.image"
            :src="urlFor(object.image.asset._ref).height(464).width(464).fit('crop').url()"
            :alt="object.image.alt"
            class="object-cover object-center w-full aspect-[1/1] rounded"
            width="464"
            height="464"
            quality="70"
            loading="lazy"
          />
        </div>
        <div
          class="relative px-4 lg:px-0"
          :class="{
            'order-2': object.imagePosition === 'imageLeft',
            'order-1': object.imagePosition !== 'imageLeft',
          }"
        >
          <div class="max-w-lg pr-0 lg:pr-12 xl:pr-0">
            <div v-if="object.eyebrow" class="eyebrow">
              {{ object.eyebrow }}
            </div>
            <h3 v-if="object.title" class="thin-title">
              {{ object.title }}
            </h3>
            <div v-if="object.body" class="text-gray-700">
              <SanityContentWrapper
                :blocks="object.body"
              />
              <UiBtn
                v-if="object.linkText && object.linkUrl"
                class="mt-2"
                :to="object.linkUrl"
                :padded="false"
                variant="link"
                size="sm"
              >
                {{ object.linkText }}
              </UiBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </UiFader>
</template>
